import React, { memo } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { SECTION_NAMES } from '../utils/constants';
import { trackFeatureClicked } from '../utils/analytics';
import CategoryTag from './CategoryTag';
import './FeatureItem.css';

const FeatureItem = memo(({ feature, year, sectionName, activeCategoryFilters, onCategoryFilterToggle }) => {
  // Handle both old string format and new object format for backward compatibility
  const featureName = typeof feature === 'string' ? feature : feature.name;
  const platform = feature.platform || [];
  const category = feature.category || '';
  const keyword = feature.keyword || '';
  const url = feature.url || '';
  const status = feature.status || '';
  const note = feature.note || '';
  const isDeprecated = status === 'deprecated';

  // Only show category tags for "Frameworks & APIs" section
  const showCategoryTag = sectionName === SECTION_NAMES.FRAMEWORKS_APIS;
  const isCategoryActive = activeCategoryFilters && activeCategoryFilters.has(category);

  const handleFeatureClick = (e) => {
    // Prevent click when clicking on category tag
    if (e.target.closest('.category-tag')) {
      return;
    }

    let targetUrl = '';

    if (sectionName === SECTION_NAMES.FRAMEWORKS_APIS && keyword) {
      // For Frameworks & APIs, use keyword search
      // Preserve existing "+"-as-space encoding in keyword data while safely escaping any other special characters
      targetUrl = `https://developer.apple.com/search/?q=${encodeURIComponent(keyword).replace(/%2B/g, '+')}`;
    } else if (url) {
      // For other sections, use fixed URL if available
      targetUrl = url;
    }

    if (targetUrl) {
      // Track feature click
      trackFeatureClicked(featureName, platform[0] || 'Unknown', year);
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const isClickable = (sectionName === SECTION_NAMES.FRAMEWORKS_APIS && keyword) || url;

  return (
    <li
      className={`feature-item ${isClickable ? 'clickable' : ''} ${isDeprecated ? 'deprecated' : ''}`}
      onClick={isClickable ? handleFeatureClick : undefined}
    >
      <div className="feature-content">
        <div className="feature-text-container">
          <span className={`feature-name ${isDeprecated ? 'deprecated-text' : ''}`}>{featureName}</span>
          {isDeprecated && note && (
            <span className="feature-note">{note}</span>
          )}
          {typeof feature === 'object' && category && showCategoryTag && (
            <div className="category-tags-container">
              <CategoryTag
                category={category}
                isActive={isCategoryActive}
                onClick={onCategoryFilterToggle}
                size="small"
              />
            </div>
          )}
        </div>
        {isClickable && <FaChevronRight className="feature-chevron" size={16} />}
      </div>
    </li>
  );
});

FeatureItem.displayName = 'FeatureItem';

export default FeatureItem;